import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_BASE_URL } from "../utils/constants";

export const useExclusaoOrchestrator = () => {
  const { hash } = useParams();
  const navigate = useNavigate();

  const [exclusaoData, setExclusaoData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorInfo, setErrorInfo] = useState({
    show: false,
    message: "",
    status: null,
  });

  const displayError = useCallback((message, status = null) => {
    setErrorInfo({ show: true, message, status });
    setTimeout(
      () => setErrorInfo({ show: false, message: "", status: null }),
      4000
    );
  }, []);

  const fetchExclusaoData = useCallback(async () => {
    if (!hash) return;
    setLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/api/v1/exclusao/${hash}`);
      setExclusaoData(response.data);
    } catch (error) {
      const status = error.response?.status || null;
      const msg =
        error.response?.data?.message ||
        "Não foi possível carregar os dados da exclusão.";
      displayError(msg, status);
      setExclusaoData(null);
    } finally {
      setLoading(false);
    }
  }, [hash, displayError]);

  useEffect(() => {
    fetchExclusaoData();
  }, [fetchExclusaoData]);

  const handleConfirmar = async () => {
    try {
      await axios.post(`${API_BASE_URL}/api/v1/exclusao/${hash}/confirmar`);
      navigate(`/caso/excluir/sucesso/${hash}`, { state: { acao: "confirmado" } });
    } catch (error) {
      const status = error.response?.status || null;
      const msg =
        error.response?.data?.message ||
        "Não foi possível confirmar a exclusão. Recarregue a página e tente novamente.";
      displayError(msg, status);
      await fetchExclusaoData();
    }
  };

  const handleRejeitar = async () => {
    try {
      await axios.post(`${API_BASE_URL}/api/v1/exclusao/${hash}/rejeitar`);
      navigate(`/caso/excluir/sucesso/${hash}`, { state: { acao: "rejeitado" } });
    } catch (error) {
      const status = error.response?.status || null;
      const msg =
        error.response?.data?.message ||
        "Não foi possível registrar sua resposta. Recarregue a página e tente novamente.";
      displayError(msg, status);
      await fetchExclusaoData();
    }
  };

  return {
    exclusaoData,
    loading,
    errorInfo,
    fetchExclusaoData,
    handleConfirmar,
    handleRejeitar,
  };
};

